import Paper from "@material-ui/core/Paper";
import React, { useState, useMemo } from "react";
import { fetchJSON } from "helpers/axios";
import { useLocation } from "react-router-dom";

const AdmissionLetter = () => {
  const location = useLocation();
  // const url = window.location.href;
  const url = location.search;

  // let urlParams = new URLSearchParams(url);
  // const applicantId = urlParams.get("applicantId");
  const applicantId = url !== "" ? url?.match(/applicantId=(.*)/)[1] : "";
  if (applicantId == "") {
    window.location.href = "/portal";
  }

  const [letterAdm, setLetterAdm] = useState(null);

  useMemo(async () => {
    // debugger;
    try {
      const response = await fetchJSON(
        `api/ProvisionalAdmissionLetter?applicantId=${applicantId}`,
        null,
        "GET"
      );
      setLetterAdm(response);
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <div className="mx-auto my-3">
      <Paper elevation={2}>
        <div id="content">
          <header
            className=" mt-4 text-center"
            // style={{ borderBottom: "1px solid gray" }}
          >
            <div>
              <img
                className="img-fluid"
                src="https://res.cloudinary.com/dkyb7lx0u/image/upload/v1760534527/d9a07e95-8054-49d8-914d-ff81113e12f9_wrxzq5.jpg"
                alt=""
                style={{ maxWidth: "120px", maxHeight: "150px" }}
              />
            </div>
            <div className="mt-1 d-flex justify-content-center align-items-center">
              <div>
                <h1 style={{ color: "#000", fontSize: "25px" }}>
                  <strong>Ondo State College of Health Technology, Akure.</strong>
                  <br />
                  
                </h1>
                <br />
              </div>
            </div>
          </header>

          {letterAdm && (
            <div className="container">
              <div
                className="d-flex justify-content-between"
                style={{ fontSize: "20px" }}
              >
                <div>
                  <strong>
                    <p>Professor Augustine Oko Angba</p>
                  </strong>
                  <strong>
                    <p>Vice Chancellor</p>
                  </strong>
                  <strong>
                    <p
                      className="text-muted"
                      style={{ fontSize: "15px", fontStyle: "italic" }}
                    >
                      Our Ref: UNICROSS/AD/VOL.20/3\5846
                    </p>
                  </strong>
                </div>
                <div style={{ fontSize: "20px" }}>
                  <strong>
                    <p>Victor Ephraim Ene</p>
                  </strong>
                  <strong>
                    <p>Registrar</p>
                  </strong>
                  <strong>
                    <p
                      className="text-muted"
                      style={{ fontSize: "15px", fontStyle: "italic" }}
                    >
                      {" "}
                      Date: {letterAdm.Data?.admissionDate}
                    </p>
                  </strong>
                </div>
              </div>
              <hr
                style={{
                  border: "1px solid black",
                }}
              />
              <div className="d-flex justify-content-between mt-4 text-left">
                <h4 style={{ fontSize: "20px" }}>
                  <strong>
                    {letterAdm.Data.lastName}, {letterAdm.Data.firstName}{" "}
                    {letterAdm.Data.otherName}
                  </strong>
                </h4>
                <h5
                  style={{
                    fontSize: "20px",
                    color: "black",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  JAMB Reg. No.:<strong>{letterAdm.Data.jambRegNo}</strong>
                </h5>
              </div>

              {/* <hr
              style={{
                fontSize: "15px",
                color: "black",
                fontWeight: "bold",
              }}
            /> */}
              <div
                style={{ fontSize: "15px", color: "black" }}
                className="row mt-1"
              >
                <div className="letter">
                  <h4
                    className="d-flex justify-content-center mt-3 mb-3"
                    style={{ fontSize: "25px" }}
                  >
                    <strong>
                      <u>
                        {(letterAdm?.Data?.EntryModeId === 1 && 3
                          ? "UTME"
                          : "") ||
                          (letterAdm?.Data?.EntryModeId === 2
                            ? "Direct Entry"
                            : "") ||
                          (letterAdm?.Data?.EntryModeId === 3 ? "UTME" : "")}
                      </u>
                    </strong>
                  </h4>
                  <h4
                    className="d-flex justify-content-center"
                    style={{ fontSize: "20px" }}
                  >
                    <strong>
                      PROVISIONAL ADMISSION FOR {letterAdm.Data.session}{" "}
                      ACADEMIC SESSION
                    </strong>
                  </h4>

                  <p>
                    You have been offered Provisional Admission via{" "}
                    {/* <strong>{letterAdm.Data.EntryMode}</strong>  */}
                    into Ondo State College of Health Technology, Akure.,
                    for the {letterAdm.Data.session} to do{" "}
                    <strong>B.Sc. ({letterAdm.Data.courseOfStudy})</strong>{" "}
                    programme in the <strong>{letterAdm.Data.faculty}.</strong>
                  </p>
                </div>
              </div>

              <div style={{ fontSize: "15px", color: "black" }}>
                <h4>Please note the following:</h4>
                <br />

                <ol>
                  <li>
                    If you accept this offer, kindly complete the attached form
                    and return it to your Department.
                  </li>{" "}
                  <br />
                  <li>
                    You are expected to commence and complete registration
                    within two weeks of resumption. Late registration attracts a
                    fee.
                    <br />
                    You will be required to present the following documents
                    during Registration; i. JAMB Admission Letter.
                    <br />
                    ii. The original and 3 photocopies of Certificates/Statement
                    of Results.
                    <br />
                    iii. Letter of Provisional Admission.
                    <br />
                    iv. Evidence of payment of School Fees.
                    <br />
                    v. Certificate of Origin, Birth Certificate (or Sworn
                    Declaration of Age). <br />
                    vi. Letters of Attestation from any two of the following:
                    <ul>
                      <li>
                        A serving Senior Government Official (Level 12 and
                        above)
                      </li>
                      <li>A Religious Leader</li>
                      <li>A Traditional Leader</li>
                    </ul>
                  </li>
                  <li>
                    If it is discovered at any time that you do not possess any
                    of the qualifications which you claim to have obtained, you
                    will be required to withdraw from the Institution.
                  </li>
                  <li>
                    Students are expected to undergo a Medical Examination in
                    the University Medical Centre and obtain a Certificate of
                    Fitness.
                  </li>
                </ol>
                <span style={{ fontSize: "20px", fontStyle: "italic" }}>
                  <strong>Congratulations on your admission.</strong>
                </span>
              </div>
              <br />
              <br />

              <div className="d-flex justify-content-between mb-5">
                <div>
                  <img
                    src="https://unicrossdoc.blob.core.windows.net/assignment/283a7e72-96e5-49f9-9a0c-34c1ff442ba2.jpg"
                    alt="VC signature"
                    style={{ height: "40%", width: "70%" }}
                  />
                  <h5>
                    <strong>Professor Augustine Oko Angba</strong>
                    <br />
                    <span style={{ fontSize: "15px" }}>Vice Chancellor</span>
                  </h5>
                </div>
                <div className="texxt-center">
                  <h5 className="text-muted mt-5" style={{ fontSize: "15px" }}>
                    Verify Document
                  </h5>
                  <div>
                    <img
                      className="img-fluid"
                      src={letterAdm.Data.QRcode}
                      alt=""
                      style={{ maxWidth: "80px", maxHeight: "100px" }}
                    />
                  </div>
                </div>
                <div>
                  <img
                    src="https://unicrossdoc.blob.core.windows.net/assignment/58857216-2435-4faf-9c05-048fd4345e9d.jpg"
                    alt="Registrar signature"
                    style={{ height: "40%", width: "70%" }}
                  />
                  <h5>
                    <strong>Victor Ephraim Ene</strong>
                    <br />
                    <span style={{ fontSize: "15px" }}>Registrar</span>
                  </h5>
                </div>
              </div>
            </div>
          )}
        </div>
      </Paper>
    </div>
  );
};

export default AdmissionLetter;
